import {
  createSearchAlert
} from "./chunk-ZMHFAQNV.js";
import {
  getConfigWithMetadata,
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  mapSearchListingsFiltersToSearchFilterRequest
} from "./chunk-KLW2VFR7.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/createSearchAlert/createSearchAlert.ts
async function createSearchAlert2(payload, options, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "createSearchAlert");
    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
      );
    }
    const requestPayload = {
      ...payload,
      searchAlert: {
        ...payload.searchAlert,
        searchFilter: mapSearchListingsFiltersToSearchFilterRequest(payload.searchAlert.searchFilter, options)
      }
    };
    const response = await createSearchAlert(requestPayload, _apiConfig);
    return {
      status: "success",
      data: response
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  createSearchAlert2 as createSearchAlert
};
